import PropTypes from 'prop-types';

const fieldShape = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    type: PropTypes.oneOf(['list', 'select', 'text', 'number-select', 'date']),
    allowEmpty: PropTypes.bool,
    dataSource: PropTypes.any
};

const selectorShape = {
    field: PropTypes.string,
    value: PropTypes.any,
    isValid: PropTypes.bool.isRequired
};

export { fieldShape, selectorShape };